import arrowRight from '../../images/arrow_right.svg';

interface IProps {
  onClick: (e: React.MouseEvent<HTMLTableCellElement>) => void;
}

export const RedirectButton = ({ onClick }: IProps) => (
  <td
    onClick={onClick}
    style={{
      cursor: 'pointer',
      textAlign: 'center',
    }}
  >
    <img
      src={arrowRight}
      style={{
        objectFit: 'contain',
      }}
      alt="arrow_right"
    />
  </td>
);
